import React from 'react';
import classNames from 'classnames';
const ContentBlock = ({ className, shadow, children, footerContent }) => (<div className={classNames('content-block', className, {
        'content-block--shadow': shadow,
    })}>
        {children}
        {footerContent && <div className="content-block__footer">{footerContent}</div>}
    </div>);
ContentBlock.defaultProps = {
    className: '',
    shadow: false,
};
export default ContentBlock;
